import toast from "react-hot-toast";
import { client } from "@/app/ApolloClient";
import { gql } from "@apollo/client";

const query = gql`
  query formSubmissionByResourceId($organizationId: UUID!, $resourceId: UUID!) {
    formSubmissionByResourceId(organizationId: $organizationId, resourceId: $resourceId){
      resource_id
      template_id
      version
      submission_id, 
      created_ts
    }

  }
`;

export function apiGetSubmissionsByResourceId(organizationId, resourceId) {
  return new Promise(async (resolve, reject) => {
    if (!organizationId) return reject("organizationId is required");
    if (!resourceId) return reject("resourceId is required");

    client
      .query({
        query: query,
        variables: { organizationId, resourceId },
        errorPolicy: "ignore",
        fetchPolicy: "network-only"
      })
      .then((result) => {
        resolve(result.data.formSubmissionByResourceId || []);
      })
      .catch((err) => {
        toast.error("API Error: Unable to get form submissions");
        reject(err);
      });
  });
}
